import { useTranslation } from 'react-i18next';

import { usePropertyState } from './usePropertyState';

export const usePropertyNameValue = () => {
  const { t } = useTranslation();
  const {
    state: { propertyId, propertyName },
  } = usePropertyState();

  if (propertyName) return propertyName;

  if (propertyId && propertyId !== 'create') return t('Loading...');

  return t('Create rental');
};
